<template>
  <header class="relative lg:fixed bg-white w-full shadow-lg z-40">
    <div class="na-content px-8 lg:flex lg:justify-between lg:items-end">
      <div class="flex w-full lg:w-auto justify-between">
        <div class="py-1">
          <a class="mb-0" href="/">
            <img class="w-16 xl:w-20 xxl:w-24" src="/wp-content/themes/naturarvet-2.0/assets/img/logo3.png" alt="Naturarvet">
          </a>
        </div>
        <div class="hidden">
          <klarna-instant-shopping
            v-pre
            data-instance-id="button-onetime"
          />
          <klarna-instant-shopping
            v-pre
            data-instance-id="button-recurring"
          />
        </div>
        <div class="flex items-center justify-end">
          <button @click="menuOpen = !menuOpen" type="button" class="lg:hidden block text-gray-900 focus:text-gray-400 focus:outline-none hover:text-gray-500">
            <svg class="w-8 h-8 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path v-if="menuOpen" fill="#626262" d="M13.41 12l4.3-4.29a1 1 0 10-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 00-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 000 1.42 1 1 0 001.42 0l4.29-4.3 4.29 4.3a1 1 0 001.42 0 1 1 0 000-1.42z"/>
              <g v-if="!menuOpen" fill="#626262"><rect x="3" y="11" width="18" height="2" rx=".95" ry=".95"/><rect x="3" y="16" width="18" height="2" rx=".95" ry=".95"/><rect x="3" y="6" width="18" height="2" rx=".95" ry=".95"/></g>
            </svg>
          </button>
          <button @click="supportUs()"
            id="supportUs"
            type="button"
            v-if="shoppingCart == 0"
            class="block lg:hidden btn btn-primary mt-0 rounded-full ml-4 text-sm xl:text-base py-2 px-3"
          >Ge en gåva</button>
          <transition name="bounce">
            <button @click="showShoppingCart"
               v-if="shoppingCart > 0"
               type="button"
               class="flex relative lg:hidden justify-center mx-4"
               >
               <svg class="text-nagreen fill-current w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M4 2h16l-3 9H4a1 1 0 1 0 0 2h13v2H4a3 3 0 0 1 0-6h.33L3 5 2 2H0V0h3a1 1 0 0 1 1 1v1zm1 18a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm10 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/></svg>
               <span class="absolute rounded-full top-0 bg-red-500 px-2 -mt-2 ml-4 z-1 leading-thight text-xs text-white">{{shoppingCart}}</span>
            </button>
          </transition>
        </div>
      </div>
      <div class="flex">
        <div :class="menuOpen ? 'block' : 'hidden'" class="self-end navmenu lg:block" v-html="items">
        </div>
        <button @click="supportUs()"
          id="supportUs"
          v-if="shoppingCart == 0"
          type="button"
          class="hidden lg:block btn self-center btn-primary mt-0 rounded-full ml-4 text-sm xl:text-base py-2 px-3"
        >Ge en gåva</button>
        <transition name="bounce">
          <button @click="showShoppingCart"
             v-if="shoppingCart > 0"
             type="button"
             class="hidden relative lg:flex items-center flex-col justify-center w-24 mr-4"
             >
             <svg class="text-nagreen fill-current w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M4 2h16l-3 9H4a1 1 0 1 0 0 2h13v2H4a3 3 0 0 1 0-6h.33L3 5 2 2H0V0h3a1 1 0 0 1 1 1v1zm1 18a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm10 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/></svg>
             <span class="absolute rounded-full top-0 bg-red-500 px-2 mt-1 ml-6 z-1 leading-thight text-xs text-white">{{shoppingCart}}</span>
          </button>
        </transition>
      </div>
      <modal transition="overlay-fade"
        :delay="100"
        :adaptive="true"
        name="donationModal"
        height="auto"
        :scrollable="true"
        :maxWidth="504"
        classes="mt-2 mb-8i"
        width="100%"
      >
        <div @click="closeDonationModal" class="absolute top-0 right-0 cursor-pointer w-6 h-6 mt-2 mr-2 z-50 text-gray-400 hover:text-black text-smaller">
          <svg class="fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
            <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
          </svg>
        </div>
        <transition :name="slideDirection">
          <div key="first" v-if="step=='first'" class="flex flex-col text-center items-center">
            <ValidationObserver v-slot="{ invalid }">
              <span class="block font-bold text-md mt-8 uppercase text-green-800">Hur ofta vill du ge?</span>
              <div class="flex flex-row justify-center items-center space-x-4">
                <button type="button" :class="activeClass(oneTimeGift)" class="btn btn-secondary text-sm md:text-base normal-case btn-border" @click="oneTimeGift = true">En gång</button>
                <button type="button" :class="activeClass(!oneTimeGift)" class="btn btn-secondary text-sm md:text-base normal-case btn-border" @click="oneTimeGift = false">Varje månad</button>
              </div>
              <span class="block font-bold text-md mt-10 uppercase text-green-800">Hur mycket skog vill du bevara?</span>
              <div class="flex flex-row justify-center items-center space-x-4">
                <button type="button" :class="activeClass(gift == 100)" class="btn btn-secondary text-sm md:text-base normal-case btn-border" @click="setAmount(100)">100 kr</button>
                <button type="button" :class="activeClass(gift == 200)" class="btn btn-secondary text-sm md:text-base normal-case btn-border" @click="setAmount(200)">200 kr</button>
                <button type="button" :class="activeClass(gift == 500)" class="btn btn-secondary text-sm md:text-base normal-case btn-border" @click="setAmount(500)">500 kr</button>
                <button type="button" :class="activeClass(showCustomAmount)" class="btn btn-secondary text-sm md:text-base normal-case btn-border" @click="selectCustomAmount">Valfritt</button>
              </div>
              <div class="flex flex-row justify-center text-left mt-3 w-full" :class="showCustomAmount ? 'block' : 'hidden'">
                <TextInput v-model="customAmount" name="Belopp" type="tel" :customMessages="{ 'required': 'Ange belopp' }" :rules="{required: true, minValue: testmode ? 5 : 50 }" placeholder="Belopp"></TextInput>
              </div>
              <div class="mt-2 text-gray-600">{{ giftAmount() }} kr skyddar {{ 0.1 * giftAmount() }} m&#178; gammelskog i Sverige</div>
              <div class="flex justify-center items-end mb-6 mt-12">
                <div class="flex flex-col">
                  <img class="h-5 mb-1" src="/wp-content/themes/naturarvet-2.0/assets/img/klarna.svg">
                  <button type="button" :disabled="showCustomAmount && invalid" class="btn btn-secondary py-4 text-sm md:text-base normal-case btn-border" @click.prevent="triggerKlarnaPopup">Ge med Klarna</button>
                </div>
                <div v-if="oneTimeGift" class="ml-6 flex flex-col">
                  <img class="h-7" src="/wp-content/themes/naturarvet-2.0/assets/img/swish-logotype.svg">
                  <button type="button" :disabled="showCustomAmount && invalid" class="btn btn-secondary py-4 text-sm md:text-base normal-case btn-border ml-2 md:ml-5" @click="triggerSwishDonation">Ge med Swish</button>
                </div>
              </div>
            </ValidationObserver>
          </div>
          <div key="second" v-if="step=='swishPhone'" class="flex flex-col mb-8 justify-center text-center items-center">
            <img class="my-10 w-40 h-20 mx-auto" src="/wp-content/themes/naturarvet-2.0/assets/img/swish-logotype.svg"> 
            <div class="w-80">
              <ValidationObserver v-slot="{ invalid }">
                <TextInput v-model="phone" name="Ange ditt nummer kopplat till Swish" :customMessages="{ 'required': 'Ange ditt telefonnummer' }" type="tel" rules="required|tel" placeholder="Telefonnummer"></TextInput>
                <div class="mt-4">
                  <TextInput v-model="email" name="Email" type="email" autocomplete="email" :rules="{ required: newsletterSignup, email: true }" placeholder="E-post"></TextInput>
                </div>
                <div class="mt-4">
                  <input type="checkbox" id="newsletter" v-model="newsletterSignup">
                  <label for="newsletter">Jag vill ha Naturarvets nyhetsbrev</label>
                </div>
                <span v-if="swishError" class="text-error block bg-red-100 rounded p-2 my-2">{{ swishError }}</span>
                <button type="button" :disabled="invalid" :class="[ swishError ? 'mt-0' : 'mt-8' ]" class="btn btn-secondary text-sm md:text-base normal-case btn-border" @click.prevent="donateWithSwish">Donera nu</button>
              </ValidationObserver>
            </div>
          </div>
          <div v-if="step=='openSwish'" key="openApp" class="h-full items-center justify-center flex flex-col">
            <img src="/wp-content/themes/naturarvet-2.0/assets/img/swish-logotype.svg" class="w-40 h-20 mt-8">
            <div class="mt-8 mb-4 text-center max-w-full">Öppna din Swish-app för att slutföra din betalning.</div>
            <div class="lds-dual-ring mt-4"></div>
            <button type="button" class="btn btn-border mb-4 py-1 px-3 normal-case" @click="cancelSwish">Avbryt</button>
          </div>
        </transition>
      </modal>
      <ThankYouModal
        :show="showThankYou"
        :assets="assets"
        title="Tack för din gåva!"
        :bodyMessage="`Tack för din gåva om ${giftAmount()} kr till Naturarvet.`"
        @button1Click="showThankYou = false"
        button1Title="Stäng">
      </ThankYouModal>
    </div>
  </header>
</template>

<script>
  import axios from 'axios'
  import TextInput from './TextInput.vue'
  import { ValidationObserver } from 'vee-validate'
  import Bugsnag from '@bugsnag/js'
  import ThankYouModal from './ThankYouModal.vue'
  export default {
    components: {
      TextInput, ValidationObserver, ThankYouModal,
    },
    data() {
      return {
        showThankYou: false,
        menuOpen: false,
        shoppingCart: 0,
        oneTimeGift: true,
        gift: 100,
        customAmount: null,
        showCustomAmount: false,
        klarna: null,
        testmode: false,
        slideDirection: 'slide-left',
        step: 'first',
        email: undefined,
        phone: undefined,
        loading: false,
        timer: null,
        timeWaitedForSwish: 0,
        swishError: null,
        newsletterSignup: false,
      }
    },
    mounted() {
      this.$root.$on('addToShoppingCart', (items = 1) => {
        this.shoppingCart += items
      })
      this.$root.$on('emptyShoppingCart', () => {
        this.shoppingCart = 0
      })
      let uri = window.location.search.substring(1)
      let params = new URLSearchParams(uri)
      this.testmode = params.has('test')
    },
    methods: {
      closeDonationModal() {
        this.$modal.hide('donationModal')
      },
      setAmount(amount) {
        this.gift = amount
        this.customAmount = null
        this.showCustomAmount = false
      },
      async cancelSwish() {
        await axios.delete(`/wp-json/naturarvet/v1/swishDonation/${this.swishId}`)
        this.slideDirection = 'slide-right'
        this.step = 'swishPhone'
        this.loading = false
        clearTimeout(this.timer)
      },
      hideSwish(message) {
        this.slideDirection = 'slide-right'
        this.loading = false
        this.step = 'swishPhone'
        this.swishError = message
      },
      selectCustomAmount() {
        this.gift = 0
        this.showCustomAmount = true
      },
      activeClass(bool) {
        return bool ? 'bg-nagreen-light text-white hover:bg-nagreen-light' : ''
      },
      supportUs() {
        this.showCustomAmount = false
        this.customAmount = null
        this.slideDirection = 'slide-left'
        this.loading = false
        this.step = 'first'
        this.swishError = null
        this.$modal.show('donationModal');
      },
      showShoppingCart() {
        this.$root.$emit('showShoppingCart')
      },
      giftAmount() {
        return this.customAmount ? this.customAmount : this.gift
      },
      triggerSwishDonation() {
        this.step = 'swishPhone'
      },
      async donateWithSwish() {
        this.slideDirection = 'slide-left'
        this.swishError = undefined
        this.step = 'openSwish'
        this.timeWaitedForSwish = 0
        try {
          const { data } = await axios.post(
            '/wp-json/naturarvet/v1/swishDonation',
            {
              amount: this.giftAmount(),
              email: this.email,
              phone: this.phone,
              newsletterSignup: this.newsletterSignup,
              testmode: this.testmode,
            }
          )
          if (!data.id) {
            this.hideSwish("Kunde inte starta Swish betalningen, försök igen eller välj ett annat betalsätt.")
            return
          }
          this.swishId = data.id
          this.timer = setTimeout(this.swishStatus, 1000)
        } catch(e) {
          Bugsnag.notify(e)
          this.hideSwish(e.response && e.response.data.message ?
            e.response.data.message :
            "Kunde inte starta Swish betalningen, försök igen eller välj ett annat betalsätt."
          )
        }
      },
      async swishStatus() {
        try {
          this.timeWaitedForSwish = this.timeWaitedForSwish + 1
          if (this.timeWaitedForSwish >= 60*3) {
            this.hideSwish("Swish betalningen hann inte bli klar i tid. Försök igen eller välj ett annat betalsätt.")
            return
          }
          const { data } = await axios.get(`/wp-json/naturarvet/v1/swishStatus/${this.swishId}`)
          if (data.status == 'CREATED') {
            this.timer = setTimeout(this.swishStatus, 1000)
            return
          }
          if (data.status == 'PAID') {
            this.$modal.hide('donationModal')
            this.showThankYou = true
            return
          }
          if (data.status == 'DECLINED') {
            this.hideSwish("Swish betalningen avvisades. Försök igen eller välj ett annat betalsätt.")
          } else {
            this.hideSwish(data.message ||
              "Något gick fel, försök igen eller kontakta givarservice på 070-648 47 89")
          }
        } catch (e) {
          Bugsnag.notify(e)
          this.hideSwish("Något gick fel, försök igen eller kontakta givarservice på 070-648 47 89")
        }
      },
      triggerKlarnaPopup() {
        this.closeDonationModal()
        const settings = {
          "setup": {
            "instance_id": this.oneTimeGift ? "button-onetime" : "button-recurring",
          },
          "tokenization": {
            "description": "Din gåva dras varje månad från och med idag, vid detta köps datum"
          },
          "purchase_country": "SE",
          "purchase_currency": "SEK",
          "locale": "sv-SE",
          "merchant_urls": {
            "terms": "https://naturarvet.se/integritetspolicy"
          },
          "order_lines": [{
            "type": "digital",
            "reference": this.oneTimeGift ? "one-time-gift" : "recurring-gift",
            "name": this.oneTimeGift ? `Gåva ${this.giftAmount()} kr` : `Månadsgivare ${this.giftAmount()} kr`,
            "quantity": 1,
            "unit_price": this.giftAmount() * 100,
            "tax_rate": 0,
            "total_amount": this.giftAmount() * 100,
            "total_tax_amount": 0,
            "image_url": "https://naturarvet.se/wp-content/themes/naturarvet-2.0/assets/img/logo3.png",
          }]
        }
        window.Klarna.InstantShopping.update(settings, (response) => {
          console.log('Klarna.InstantShopping.update callback with data:' + JSON.stringify(response))
          window.Klarna.InstantShopping.open({
            "setup": {
              "instance_id": this.oneTimeGift ? "button-onetime" : "button-recurring"
            }}, (resp) => { console.log('open response: ' + JSON.stringify(resp)) }
          )
        })
      }
    },
    props: {
      'items': String,
      'assets': String,
    }
  }
</script>
<style lang="scss">
  .navmenu {
    @apply px-2 pt-2 pb-4 font-sans uppercase text-xs font-medium;
  }
  .navmenu > ul > li {
    @apply mt-1;
  }
  .navmenu a {
    @apply block w-full px-2 py-1 rounded;
  }
  .navmenu > ul > li a:hover {
    @apply bg-gray-400;
  }
  .navmenu > ul > li > ul a:hover {
    @apply bg-gray-400;
  }
  .navmenu > ul > li > ul {
    @apply ml-4;
  }
  @screen lg {
    #menu-header {
      @apply flex;
    }
    .navmenu {
      @apply pb-0;
    }
    .navmenu > ul > li > ul {
      @apply ml-0 hidden absolute rounded-b overflow-y-hidden bg-gray-200;
      z-index: 99;
    }
    .navmenu > ul > li {
      @apply rounded-t;
    }
    .navmenu > ul > li:hover {
      @apply bg-gray-400;
    }
    .navmenu > ul > li:hover > ul {
      @apply block;
    }
  }
  @screen xl {
    .navmenu {
      @apply text-sm;
    }
  }
  @screen xxl {
    .navmenu {
      @apply text-base;
    }
  }
  .bounce-enter-active {
    animation: bounce-in .5s;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(3);
    }
    100% {
      transform: scale(1);
    }
  }
</style>
